import { type FC, type SVGProps } from 'react'

interface SignInIconProps extends SVGProps<SVGSVGElement> {
  color?: string
}

export const SignInIcon: FC<SignInIconProps> = ({ color = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={20} fill="none" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.983 5.556a3.556 3.556 0 1 1-7.111 0 3.556 3.556 0 0 1 7.111 0zm-3.555 6.222A6.222 6.222 0 0 0 1.205 18H13.65a6.222 6.222 0 0 0-6.222-6.222z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M23.374 5.578a3.752 3.752 0 0 1-.885 5.962v1.996l-.884.884.884.884-1.768 1.769-1.768-1.769V11.54a3.75 3.75 0 1 1 4.42-5.962zm-4.421.884a.625.625 0 1 0 .884.884 1.25 1.25 0 0 1 1.768 0 .625.625 0 1 0 .884-.884 2.5 2.5 0 0 0-3.536 0z"
      clipRule="evenodd"
    />
  </svg>
)
